/** Libellés et calculs de la fiche client (/superadmin/clients/:id). */

export const SUBSCRIPTION_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Actif',
  TRIAL: 'Essai',
  PAST_DUE: 'Impayé',
  SUSPENDED: 'Suspendu',
  EXPIRED: 'Expiré',
  CANCELLED: 'Annulé',
  INACTIVE: 'Inactif',
};

export const statusLabel = (status: string | null | undefined) =>
  (status && SUBSCRIPTION_STATUS_LABELS[status.toUpperCase()]) || status || '—';

/** Quota de parcours : -1 (ou une valeur négative) = illimité. */
export function formatQuota(used: number | null | undefined, max: number | null | undefined): string {
  const usedCount = used ?? 0;
  if (max == null) return `${usedCount}`;
  return max < 0 ? `${usedCount} / illimité` : `${usedCount} / ${max}`;
}

/** Ajoute des mois en restant sur le dernier jour du mois si besoin (31 janv. + 1 mois → 28/29 févr.). */
export function addMonths(date: Date, months: number): Date {
  const result = new Date(date);
  const day = result.getDate();
  result.setDate(1);
  result.setMonth(result.getMonth() + months);
  const lastDay = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
  result.setDate(Math.min(day, lastDay));
  return result;
}

/** Point de départ d'une prolongation : l'échéance actuelle si elle est future, sinon aujourd'hui. */
export function extensionBase(dateEcheance: string | null | undefined, now = new Date()): Date {
  const current = dateEcheance ? new Date(dateEcheance) : null;
  return current && current > now ? current : now;
}

export function daysUntil(date: string | null | undefined, now = new Date()): number | null {
  if (!date) return null;
  return Math.ceil((new Date(date).getTime() - now.getTime()) / 86_400_000);
}

export function formatDate(date: string | null | undefined): string {
  return date ? new Date(date).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
}

/** Valeur d'un <input type="date"> (AAAA-MM-JJ, heure locale). */
export function toDateInputValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Échéance à la fin de la journée choisie, en ISO. */
export function dateInputToIso(value: string): string {
  return new Date(`${value}T23:59:59`).toISOString();
}

/** Message lisible d'une erreur de l'API (message + premier champ en erreur). */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as { response?: { data?: { message?: string; errors?: Record<string, string> } } })?.response?.data;
  const firstFieldError = data?.errors ? Object.values(data.errors)[0] : undefined;
  return [data?.message, firstFieldError].filter(Boolean).join(' — ') || fallback;
}
